import { type FC } from "react";
import styles from "./PaymentErrorBanner.module.scss";
import Alert from "../../../../../../components/common/messages/Alert/Alert";
import { AlertTypes } from "../../../../../../enums";

interface Props {
  message: string;
}
const PaymentErrorBanner: FC<Props> = ({ message }) => {
  return (
    <div className={styles.root}>
      <Alert
        id="payment-error"
        type={AlertTypes.error}
        title="Your card was declined."
        message={message}
        isPersistent
      />
    </div>
  );
};

export default PaymentErrorBanner;
